module.exports = __webpack_public_path__ + "media/images/flowchart_768-0b57ecd7ba894ef766d34621a9127dbf.svg";